<script setup lang="ts">
type AtomsCheckboxProps = {
  label?: string
  modelValue: boolean
}
const props = defineProps<AtomsCheckboxProps>()

const emit = defineEmits<{
  (e: 'refine'): void
}>()

const model = defineModel<boolean>({ default: false })
model.value = props.modelValue
</script>

<template>
  <label
    :for="label"
    class="text-book-6 focus-within:ring-primitives-blue flex cursor-pointer items-center gap-x-3 focus-within:ring-1"
  >
    <div class="inputCheckbox">
      <input
        :id="label"
        v-model="model"
        type="checkbox"
        @click="emit('refine')"
      />
      <div class="iconInput">
        <DefaultIconsCheck aria-hidden="true" />
      </div>
    </div>
    <div v-if="$slots.label" class="flex gap-x-1">
      <slot name="label" />
    </div>
    <div v-else>
      {{ label }}
    </div>
  </label>
</template>
